
import React from 'react';
import { LanguageOption } from '../types'; // Assuming LanguageOption is general enough

interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: LanguageOption[];
  className?: string;
  label?: string; // Optional label
  id: string; // Required for label association
}

const SelectInput: React.FC<SelectInputProps> = ({ options, className = '', label, id, ...props }) => {
  return (
    <div className="w-full">
      {label && <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-1">{label}</label>}
      <select
        id={id}
        className={`block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm ${className}`}
        {...props}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.flag} {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
    